// extracted by mini-css-extract-plugin
module.exports = {"footerMenus__menu":"ct_p0","footerMenus__menu_isNoMargin":"ct_p1"};